import CmsBaseClass from "@/helpers/cms/CmsBaseClass.js";

export default class CmsPluginLiquidComponent extends CmsBaseClass {
    constructor(data) {
        super(data);

        if (!data) {
            this.active = true;
            this.code = ``;
        }
    }
}
